import React from 'react';
import styled from 'styled-components';
import { WarningIcon, CaptionStyle, BodyTextStyle } from '@kvdbil/components';
import StructuredText from '~/App/components/DatoCMS/StructuredText';
import { StructuredTextData } from '~/App/shared/interfaces/datoCMS';

const Container = styled.div`
  display: grid;
  grid-template-columns: max-content auto;
  column-gap: 1rem;
  align-items: center;

  svg {
    font-size: 4.5rem;
    color: ${({ theme }) => theme.colors.error.dark};
  }
`;

const StructuredTextWrapper = styled.div`
  > h6 {
    ${BodyTextStyle}
    margin-bottom: 0.5rem;
  }
  > p {
    ${CaptionStyle}
  }
`;

type Props = {
  content: StructuredTextData;
};

export const LoanWarning = ({ content }: Props) => {
  return (
    <Container>
      <WarningIcon color="error" />
      <StructuredText data={content} wrapper={StructuredTextWrapper} />
    </Container>
  );
};
